<template>
  <transition name="slide-fade">
    <v-container fluid class="px-0">
      <v-layout wrap>
        <v-flex xs12>
          <v-card class="elevation-24">
            <v-card-title class="py-0" v-show="registerAsUser">
              <v-spacer></v-spacer>
              <span>Register</span>
              <v-btn small icon fab color="orange" @click="info = !info">
                <v-icon>{{ icons.help }}</v-icon>
              </v-btn>
            </v-card-title>
            <v-card-text>
              <transition-group name="custom-classes-transition" enter-active-class="animate__animated animate__rollIn" leave-active-class="animate__animated animate__rollOut" mode="out-in">
                <v-layout wrap v-show="!registerAsUser" key="choose" class="pt-11">
                  <v-flex md5 sm5 xs12 class="text-center">
                    <v-btn large @click="goTo('/professional/register')" color="light-blue">Register as a Professional</v-btn>
                  </v-flex>
                  <v-flex md2 sm1 xs12 class="text-center">
                    <v-divider :vertical="!$breakpoint.xsOnly"></v-divider>
                  </v-flex>
                  <v-flex md5 sm5 xs12 class="text-center">
                    <v-btn large @click="goTo('/client/register')" color="primary">Register as a Patient</v-btn>
                  </v-flex>
                  <v-flex xs12 class="my-2 text-center">
                    <a @click="registerAsUser = true">No, I just want to explore</a>
                  </v-flex>
                </v-layout>
                <form ref="register" @submit.prevent="registerUser" v-show="registerAsUser" key="register">
                  <v-layout wrap>
                    <v-flex xs12 sm6 md6 class="sm:tw-pr-1 md:tw-pr-1">
                      <v-text-field label="First Name" required="required" v-model="user.first_name" min-length="2"></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md6 class="sm:tw-pl-1 md:tw-pl-1">
                      <v-text-field label="Last Name" required="required" v-model="user.last_name" min-length="2"></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-text-field label="Name" dense name="Name" :rules="[form_rules.required]" required="required" v-model="user.name" :error-messages="_error('name', 'createNewUser')" class="hidden"></v-text-field>
                  <v-text-field label="Email" dense type="email" name="Email" required="required" v-model="user.email" :rules="[form_rules.required, form_rules.email]" :error-messages="_error('email', 'createNewUser')" hint="Please note that you will be required to verify this email"></v-text-field>
                  <v-text-field label="Username" name="username" v-model="user.username" :error-messages="_error('username', 'createNewUser')"></v-text-field>
                  <v-text-field label="Password" v-model="user.password" name="Password" :rules="[form_rules.required]" min-length="8" type="password" :error-messages="_error('password', 'createNewUser')"></v-text-field>
                  <v-text-field type="password" dense label="Confirm Password" v-model="user.password_confirmation" name="Password Confirmation" :rules="[form_rules.required]" min-length="8"></v-text-field>
                  <referral-code :errors="errors" v-model="user.referral_code"></referral-code>
                  <v-checkbox v-model="user.terms_accepted" dense required :rules="[form_rules.required]" :error-messages="_error('terms_accepted', 'createNewUser')">
                    <template #label>
                      <p>I have read and accepted the &nbsp;<inertia-link href="/terms-of-use">Terms of Use</inertia-link>&nbsp; and the &nbsp;<inertia-link href="/privacy-policy">Privacy Policy</inertia-link>.</p>
                    </template>
                  </v-checkbox>
                  <v-btn type="submit" small color="primary" class="pull-right">Register</v-btn>
                  <v-menu open-on-hover :open-delay="100">
                    <template v-slot:activator="{ attrs, on }">
                      <v-btn small v-on="on" v-bind="attrs" title="Register as Professional or Patient">Register as Patient / Pro</v-btn>
                    </template>
                    <v-list class="purple darken-4">
                      <v-list-item href="/client/register">
                        <v-list-item-title>Register as Patient</v-list-item-title>
                      </v-list-item>
                      <v-list-item href="/professional/register">
                        <v-list-item-title>Register as Professional</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </form>
              </transition-group>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
      <mk-dialog v-model="info" heading="">
        <v-card>
          <v-card-text>
            <h3>Registration</h3>
            <p>By filling out this form, you will be able to register an account.</p>
            <p><b>However</b>, you won't be able to have a patient account or a professional account.</p>
            <p><b>You can add the required details later from your profile page.</b></p>
            <p>After you register, you will be required to confirm your email address by clicking on the link sent to the email</p>
            <h4>Professional</h4>
            <p>If you decide to add your professional details later, your account will be deactivated, until your submitted details and documents are verified. You may be required to confirm your email after that process.</p>
            <p>Alternatively, you can <inertia-link href="/professional/register">create a professional account by clicking here</inertia-link></p>
            <h4>Patient</h4>
            <p>Once you add your details for a patient, you can immediately place requests for medical services.</p>
            <p>Alternatively, you can <inertia-link href="/client/register">create a patient account by clicking here</inertia-link></p>
          </v-card-text>
        </v-card>
      </mk-dialog>
    </v-container>
  </transition>
</template>

<script>
  const MkDialog = async () => await import(/* webpackMode: 'lazy' */ /* webpackChunkName: "main-components" */ '@/Components/components/mk-dialog')
  const ReferralCode = async () => await import(/* webpackMode: 'lazy' */ /* webpackChunkName: "main-components" */ '@/Components/Referral/CheckCode')

  export default {
    name: 'Register',
    //layout,
    props: [
      'errors'
    ],
    components: {
      MkDialog,
      ReferralCode,
    },
    metaInfo () {
      return {
        title: 'Register',
        titleTemplate: '%s | ' + this.$title,
      }
    },
    data () {
      return {
        user: this.$inertia.form({
          name: '',
          email: '',
          username: '',
          password: '',
          password_confirmation: '',
          terms_accepted: false,
          first_name: '',
          last_name: '',
          referral_code: '',
        }, {
          bag: 'createNewUser'
        }),
        info: false,
        registerAsUser: false,
      }
    },
    methods: {
      registerUser () {
        swal({
          text: 'You will still need to provide additional details to place requests',
          icon: '⚠',
          title: 'Please note ⚠',
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: 'red',
          confirmButtonText:'Continue',
          cancelButtonText: 'Enter Details Now',
          closeOnConfirm: true,
          showLoaderOnConfirm: false,
        },
        function (isConfirm) {
          console.log(isConfirm, 'isConfirm');
          if (isConfirm) {
            this.user.post(route('register'))
          } else {
            this.$inertia.visit('/client/register')
          }
        }.bind(this))
      },
      getFullName () {
        this.user.name = this.user.first_name + ' ' + this.user.last_name
      }
    },
    watch: {
      'user.first_name': 'getFullName',
      'user.last_name': 'getFullName'
    }
  }
</script>

<style>
   /**/
</style>
